import Link from "next/link";
import { useRouter } from "next/router";

import { BRAND_PATHS } from "@chef/constants";
import { Button } from "@chef/components";
import { AppShell } from "@chef/feature-app-shell";
import { usePreselector } from "@chef/state-management/hooks";
import { useEffectOnce } from "@chef/hooks";

import { intl } from "./TechnicalErrorPage.Intl";

export const TechnicalErrorPage = () => {
  const router = useRouter();
  const { expire } = usePreselector();

  useEffectOnce(() => {
    expire();
  }, router.isReady);

  return (
    <AppShell title={intl.OOPSS_TECHNICAL_ISSUES}>
      <AppShell.Header />
      <AppShell.Main>
        <div className="flex flex-col items-center max-w-screen-sm gap-4 mx-auto mt-6 text-center">
          <h1 className="text-2xl">
            <strong>{intl.OOPSS_TECHNICAL_ISSUES}</strong>
          </h1>

          <p className="mb-8">
            <strong>{intl.WE_ARE_WORKING_ON_RESOLVING_IT}</strong>
          </p>

          <Link href={BRAND_PATHS.CONTACT_US_PAGE}>
            <Button primary>{intl.CONTACT_CUSTOMER_SERVICE}</Button>
          </Link>
          <Link href={BRAND_PATHS.MY_ACCOUNT_HREF}>
            <Button outlined>{intl.BACK_TO_MY_ACCOUNT}</Button>
          </Link>
        </div>
      </AppShell.Main>
      <AppShell.TabBar />
    </AppShell>
  );
};
